export const counterparty = [
  { value: "Central Bank and central government" },
  { value: "Corporate - Other than SME or specialised lending" },
  { value: "Corporate - SME only" },
  { value: "International Organisations" },
  { value: "Multilateral Development Bank" },
  { value: "Non rated credit institution" },
  { value: "Public sector entity" },
  { value: "Rated credit institution" },
  { value: "Regional government" },
  { value: "Retail" },
];
